import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import {
  VIEW_DETAILS_COMMON_KEYS,
  VIEW_CHEQUE_BOOK_DETAILS_KEYS,
  VIEW_CARD_LESS_CASH_DETAILS_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function CardLessCashDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <Row xs={12}>
      <Col className='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_CARD_LESS_CASH_DETAILS_KEYS.ACCOUNT_NO)}</label>
        <span>{option?.sourceAccountNo || '-'}</span>
        <label>{t(VIEW_CARD_LESS_CASH_DETAILS_KEYS.CURRENCY)}</label>
        <span>{option?.currency || '-'}</span>
        <label>{t(VIEW_CARD_LESS_CASH_DETAILS_KEYS.MOBILE_NO)}</label>
        <span>{option?.mobileNumber || '-'}</span>
        <label>{t(VIEW_CARD_LESS_CASH_DETAILS_KEYS.EXPIRY)}</label>
        <span>{option?.expiry || '-'}</span>
        <label>{t(VIEW_CARD_LESS_CASH_DETAILS_KEYS.AMOUNT)}</label>
        <span>
          {option?.amount} {option.txnCurrency}
        </span>
      </Col>
      <Col className='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_CARD_LESS_CASH_DETAILS_KEYS.BRANCH)}</label>
        <span>{option?.branch || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_BY)}</label>
        <span>{option?.initBy || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_DATE)}</label>
        <span>{option?.initDate !== null ? option?.initDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_DATE)}</label>
        <span>{option?.authDate !== null ? option?.authDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_STATUS)}</label>
        <span>
          {option?.authStatus === 'P'
            ? 'Pending'
            : option?.authStatus === 'A'
            ? 'Approved'
            : 'Rejected'}
        </span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.COMMENTS)}</label>
        <span>{option?.authorizerComments || '-'}</span>
      </Col>
    </Row>
  )
}
